import i18n, { i18n_t } from '@/locales/i18n';
import te1 from '@/renderer/components/dialog/IndustryInfo/images/e1.jpeg';
import te2 from '@/renderer/components/dialog/IndustryInfo/images/e2.jpeg';
import te3 from '@/renderer/components/dialog/IndustryInfo/images/e3.jpeg';
import tf1 from '@/renderer/components/dialog/IndustryInfo/images/f1.jpeg';
import tf2 from '@/renderer/components/dialog/IndustryInfo/images/f2.jpeg';
import tf3 from '@/renderer/components/dialog/IndustryInfo/images/f3.jpeg';
import tr1 from '@/renderer/components/dialog/IndustryInfo/images/r1.jpeg';
import tr2 from '@/renderer/components/dialog/IndustryInfo/images/r2.jpeg';
import tr3 from '@/renderer/components/dialog/IndustryInfo/images/r3.jpeg';
import tm1 from '@/renderer/components/dialog/IndustryInfo/images/m1.jpeg';
import tm2 from '@/renderer/components/dialog/IndustryInfo/images/m2.jpeg';
import tm3 from '@/renderer/components/dialog/IndustryInfo/images/m3.jpeg';
import tg1 from '@/renderer/components/dialog/IndustryInfo/images/g1.jpeg';
import tg2 from '@/renderer/components/dialog/IndustryInfo/images/g2.jpeg';
import tg3 from '@/renderer/components/dialog/IndustryInfo/images/g3.jpeg';

import te1en from '@/renderer/components/dialog/IndustryInfo/images/e1-en.jpeg';
import te2en from '@/renderer/components/dialog/IndustryInfo/images/e2-en.jpeg';
import te3en from '@/renderer/components/dialog/IndustryInfo/images/e3-en.jpeg';
import tf1en from '@/renderer/components/dialog/IndustryInfo/images/f1-en.jpeg';
import tf2en from '@/renderer/components/dialog/IndustryInfo/images/f2-en.jpeg';
import tf3en from '@/renderer/components/dialog/IndustryInfo/images/f3-en.jpeg';
import tr1en from '@/renderer/components/dialog/IndustryInfo/images/r1-en.jpeg';
import tr2en from '@/renderer/components/dialog/IndustryInfo/images/r2-en.jpeg';
import tr3en from '@/renderer/components/dialog/IndustryInfo/images/r3-en.jpeg';
import tm1en from '@/renderer/components/dialog/IndustryInfo/images/m1-en.jpeg';
import tm2en from '@/renderer/components/dialog/IndustryInfo/images/m2-en.jpeg';
import tm3en from '@/renderer/components/dialog/IndustryInfo/images/m3-en.jpeg';
import tg1en from '@/renderer/components/dialog/IndustryInfo/images/g1-en.jpeg';
import tg2en from '@/renderer/components/dialog/IndustryInfo/images/g2-en.jpeg';
import tg3en from '@/renderer/components/dialog/IndustryInfo/images/g3-en.jpeg';

const e1 = i18n.locale === 'zh-CN' ? te1 : te1en;
const e2 = i18n.locale === 'zh-CN' ? te2 : te2en;
const e3 = i18n.locale === 'zh-CN' ? te3 : te3en;
const f1 = i18n.locale === 'zh-CN' ? tf1 : tf1en;
const f2 = i18n.locale === 'zh-CN' ? tf2 : tf2en;
const f3 = i18n.locale === 'zh-CN' ? tf3 : tf3en;
const r1 = i18n.locale === 'zh-CN' ? tr1 : tr1en;
const r2 = i18n.locale === 'zh-CN' ? tr2 : tr2en;
const r3 = i18n.locale === 'zh-CN' ? tr3 : tr3en;
const m1 = i18n.locale === 'zh-CN' ? tm1 : tm1en;
const m2 = i18n.locale === 'zh-CN' ? tm2 : tm2en;
const m3 = i18n.locale === 'zh-CN' ? tm3 : tm3en;
const g1 = i18n.locale === 'zh-CN' ? tg1 : tg1en;
const g2 = i18n.locale === 'zh-CN' ? tg2 : tg2en;
const g3 = i18n.locale === 'zh-CN' ? tg3 : tg3en;

export type IndustryInfoType = {
  id: number;
  title: string;
  desciption: string;
  imgUrl: string;
  icon: string;
  selectedIcon: string;
  link: string;
};

export type IndustryType = 'education' | 'finance' | 'retail' | 'medical' | 'general';
export const adminCenterRouterList = ['securityScan', 'logQuery'];
export type IndustryListType = {
  id: number;
  type: IndustryType;
  title: string;
  list: Array<IndustryInfoType>;
  btnText: string;
};

const education: Array<IndustryInfoType> = [
  {
    id: 1,
    title: i18n_t('作业收集'),
    desciption: i18n_t('一键发起作业收集任务，全自动收集学生各种作业资料'),
    imgUrl: e1,
    icon: 'collect',
    selectedIcon: 'collected',
    link: 'fileCollect',
  },
  {
    id: 2,
    title: i18n_t('海量教学资料库'),
    desciption: i18n_t('存储课件论文等资料，进行教师、学生、家长间高效协同'),
    imgUrl: e2,
    icon: 'book',
    selectedIcon: 'booked',
    link: '',
  },
  {
    id: 3,
    title: i18n_t('文件安全管理'),
    desciption: i18n_t('自动检测敏感及病毒资料，及时识别风险并自动隔离'),
    imgUrl: e3,
    icon: 'safe',
    selectedIcon: 'safed',
    link: 'securityScan',
  },
];

const finance: Array<IndustryInfoType> = [
  {
    id: 1,
    title: i18n_t('文件安全管理'),
    desciption: i18n_t('多级权限管控，风险敏感文件监控，核心资料强守护'),
    imgUrl: f1,
    icon: 'safe',
    selectedIcon: 'safed',
    link: '',
  },
  {
    id: 2,
    title: i18n_t('员工安全管控'),
    desciption: i18n_t('操作行为日志记录，一键资料交接，核心数据不泄漏'),
    imgUrl: f2,
    icon: 'people',
    selectedIcon: 'peopled',
    link: 'logQuery',
  },
  {
    id: 3,
    title: i18n_t('高效办公协作'),
    desciption: i18n_t('在线编辑文档，内外高效分享协作，提升办公效率'),
    imgUrl: f3,
    icon: 'collect',
    selectedIcon: 'collected',
    link: 'teamSpace',
  },
];

const retail: Array<IndustryInfoType> = [
  {
    id: 1,
    title: i18n_t('生产资料流转'),
    desciption: i18n_t('在线编辑文档，一键发起文件审批，提升办公效率'),
    imgUrl: r1,
    icon: 'safe',
    selectedIcon: 'safed',
    link: '',
  },
  {
    id: 2,
    title: i18n_t('销售协作分享'),
    desciption: i18n_t('多空间文件一键分享，多级分享设置，快速交付方案'),
    imgUrl: r2,
    icon: 'collect',
    selectedIcon: 'collected',
    link: '',
  },
  {
    id: 3,
    title: i18n_t('员工安全管控'),
    desciption: i18n_t('操作行为日志记录，一键资料交接，核心数据不泄漏'),
    imgUrl: r3,
    icon: 'people',
    selectedIcon: 'peopled',
    link: 'logQuery',
  },
];

const medical: Array<IndustryInfoType> = [
  {
    id: 1,
    title: i18n_t('资料影像库'),
    desciption: i18n_t('自动同步备份医疗影像资料，在线播放及一键分享'),
    imgUrl: m1,
    icon: 'video1',
    selectedIcon: 'video1ed',
    link: '',
  },
  {
    id: 2,
    title: i18n_t('报告分享汇报'),
    desciption: i18n_t('多空间文件一键分享，多级分享设置，快速沟通协作'),
    imgUrl: m2,
    icon: 'collect',
    selectedIcon: 'collected',
    link: '',
  },
  {
    id: 3,
    title: i18n_t('文件签字审批'),
    desciption: i18n_t('在线编辑文档，一键发起文件审批，提升办公效率'),
    imgUrl: m3,
    icon: 'approve',
    selectedIcon: 'approved',
    link: '',
  },
];

const general: Array<IndustryInfoType> = [
  {
    id: 1,
    title: i18n_t('文件安全管理'),
    desciption: i18n_t('多级权限管控，风险敏感文件监控，核心资料强守护'),
    imgUrl: g1,
    icon: 'safe',
    selectedIcon: 'safed',
    link: '',
  },
  {
    id: 2,
    title: i18n_t('高效办公协作'),
    desciption: i18n_t('在线编辑文档，内外高效分享协作，提升办公效率'),
    imgUrl: g2,
    icon: 'cooperation',
    selectedIcon: 'cooperationed',
    link: 'teamSpace',
  },
  {
    id: 3,
    title: i18n_t('在线签合同'),
    desciption: i18n_t('一键发起电子签，签单合同安全存储，助力客户成功'),
    imgUrl: g3,
    icon: 'approve',
    selectedIcon: 'approved',
    link: 'electronicSign',
  },
];

export const industryList: Array<IndustryListType> = [
  {
    id: 1,
    type: 'education',
    title: i18n_t('教育行业-让知识更易分享和积累'),
    list: education,
    btnText: i18n_t('我知道了'),
  },
  {
    id: 2,
    type: 'finance',
    title: i18n_t('金融行业-掌控信息安全的企业生命线'),
    list: finance,
    btnText: i18n_t('我知道了'),
  },
  {
    id: 3,
    type: 'retail',
    title: i18n_t('零售行业-跨地极速传输，上下游无间协作'),
    list: retail,
    btnText: i18n_t('我知道了'),
  },
  {
    id: 4,
    type: 'medical',
    title: i18n_t('医疗行业-统一归档实现数据信息化管理'),
    list: medical,
    btnText: i18n_t('我知道了'),
  },
  {
    id: 5,
    type: 'general',
    title: i18n_t('网盘使用攻略-一站式企业文件管理协作平台'),
    list: general,
    btnText: i18n_t('我知道了'),
  },
];
